// import { projectBasicPath } from '@ps/views/workbench/utils/config'
// import store from '@ps/store'
import { isVideo } from '@ps/bridge/qc/base'
import _ from 'lodash'
import {
  transformXyLogic2Ui,
  calculateGradientCoordinate,
} from '@ps/bridge/qc/node'
import iframe, { getIframe } from '@ps/bridge/iframe/iframe'
import * as bgScript from '@ps/bridge/qc/scripts/bg-config'
// import nodePool from '@ps/bridge/qc/node-pool'
import * as sceneConfigScript from '@ps/bridge/qc/scripts/scene-config'
import nodePool from '@ps/bridge/qc/node-pool'
import captureVideo from '@com/utils/capture-video'

export async function captureCurrentScene(
  { rootState, state, commit, dispatch, getters, rootGetters },
  { captureSceneNode, captureOrientation } = {},
) {
  // 预览连线线条时不用截屏
  if (rootState.workspace.game.drawLine.previewing) return
  // 预览刚体轮廓时不用截屏
  if (
    rootState.workspace.game.previewBox2dShapeState ||
    rootState.workspace.game.previewBox2dShapeAllState
  ) {
    return
  }
  const orientation =
    typeof captureOrientation === 'undefined'
      ? rootState.workspace.game.device.orientation
      : captureOrientation
  // 获取iframe 地址
  const iframeWindowUrl = iframe.projectPath
  // 游戏画布
  const gameCanvas = getIframe().document.querySelector('#gameDiv>canvas')
  const worldScale = getIframe().UIRoot.getWorldScale()
  const gamePlay = getters.gamePlay
  const globalConfig = bgScript.getScript(gamePlay, false)
  const globalScene = rootState.workspace.game.sceneManager.sceneList.find(
    (scene) => sceneConfigScript.isGlobalScene(scene),
  )
  // 生成截图画布
  const captureCanvas = (() => {
    const tempCan = document.createElement('canvas')
    tempCan.width = gameCanvas.clientWidth
    tempCan.height = gameCanvas.clientHeight
    tempCan.style.zIndex = 999
    tempCan.style.visibility = 'hidden'
    tempCan.style.position = 'fixed'
    tempCan.style.right = 0
    tempCan.style.top = 0
    document.body.append(tempCan)
    return tempCan
  })()
  const captureCanvasCtx = captureCanvas.getContext('2d')
  const sceneNode =
    typeof captureSceneNode === 'undefined'
      ? state.sceneManager.currentSceneNode
      : captureSceneNode
  const sceneConfig = sceneNode ? sceneConfigScript.getScript(sceneNode) : {}
  const getVideoNodes = (sceneNode) => {
    let globalVideo = [] // 全局场景视频
    let currentVideo = [] // 当前场景视频
    let playUnitVideo = [] // 玩法场景视频
    if (sceneConfig.isShowGlobal) {
      globalVideo = globalScene
        ? globalScene.children.filter((node) => isVideo(node))
        : []
    }
    currentVideo = sceneNode
      ? sceneNode.children.filter((node) => isVideo(node))
      : []
    if (sceneConfig.playUUID) {
      const playScene = rootState.workspace.game.sceneManager.sceneList.find(
        (scene) => scene.uuid === sceneConfig.playUUID,
      )
      playUnitVideo = playScene
        ? playScene.children.filter((node) => isVideo(node))
        : []
    }
    return globalVideo.concat(currentVideo, playUnitVideo)
  }
  const videoNodes = sceneNode ? getVideoNodes(sceneNode) : []
  const hasBgImg =
    !!_.get(rootState.workspace.editorConfig, 'bg.value') && !!globalConfig
  let captureError = false
  const getImage = (url, isVideo = false) => {
    if (isVideo) {
      return new Promise((resolve, reject) => {
        captureVideo({
          url,
          clippingRatio: 1,
          captureCallBack: (img) => {
            const frame = img.frame[0]
            const image = new Image()
            // 支持跨域图片
            image.crossOrigin = '*'
            image.src = frame.data
            image.onload = function () {
              resolve({
                height: frame.height,
                width: frame.width,
                dom: image,
              })
            }
            image.onerror = () => {
              captureError = true
              resolve('')
            }
          },
          isCaptureCover: true,
        })
      })
    }
    return new Promise((resolve, reject) => {
      const image = new Image()
      const radom = `?v=${new Date().getTime()}`
      const isHttp = url.indexOf('http') !== -1
      // 如果是私域地址，不允许添加时间戳
      const isAmzUrl = url.includes('X-Amz-Credential')
      // 截图的地址，不允许加时间戳
      const isCapture = url.includes('common/video/capture')
      // 支持跨域图片
      image.crossOrigin = '*'
      image.src = `${url}${isHttp && !isAmzUrl && !isCapture ? radom : ''}`
      image.onload = function () {
        resolve({
          height: image.height,
          width: image.width,
          dom: image,
        })
      }
      image.onerror = () => {
        captureError = true
        resolve('')
      }
    })
  }
  let picBg
  if (hasBgImg && gamePlay.div) {
    const bgUrl = globalConfig.bgUrl
    picBg = await getImage(`${iframeWindowUrl}/${bgUrl}`)
  }

  // const captureList = [
  //   {
  //     prop: 'game',
  //     url: [gameCanvas.toDataURL('image/png')],
  //   },
  //   {
  //     prop: 'video',
  //     url: videoNodes.map((node) => {
  //       return node.Video.videoCoverUrl
  //     }),
  //   },
  //   {
  //     prop: 'bg',
  //     url: [
  //       hasBgImg && gamePlay.div
  //         ? `${iframeWindowUrl}/${globalConfig.bgUrl}`
  //         : '',
  //     ],
  //   },
  // ]

  const bgColor = (() => {
    const config = state.gamePlay.getScript('ps.GlobalConfigBg')
    if (!config || !config.bgColor) {
      return ''
    }
    const isLinear = config.bgColor.indexOf('linear') !== -1
    const getLinearByString = (value) => {
      const reg = /\((.+)\)/g
      const str = value.match(reg)
      const colors = str[0].replace(/[()]/g, '').split(',')
      return [colors[1], colors[2], colors[0]]
    }
    return {
      isLinear: isLinear,
      color: isLinear ? getLinearByString(config.bgColor) : config.bgColor,
    }
  })()

  return new Promise((resolve, reject) => {
    async function finalCanvas() {
      const drawLinearGradient = (color) => {
        let deg = Number(color[2].replace('deg', ''))
        // calculateGradientCoordinate算法无法正常计算119-151角度的正确渐变线，通过把对应角度转换成负角度hack这个问题，转换成负角度，颜色使用需要颠倒
        let hackColor = false
        if (deg >= 119 && deg <= 151) {
          hackColor = true
          deg = deg - 180
        }
        const position = calculateGradientCoordinate(
          captureCanvas.width,
          captureCanvas.height,
          deg,
        )
        const grad = captureCanvasCtx.createLinearGradient(
          position.x0,
          position.y0,
          position.x1,
          position.y1,
        ) // 径向渐变
        grad.addColorStop(0, hackColor ? color[1] : color[0]) // 定义渐变色颜色
        grad.addColorStop(1, hackColor ? color[0] : color[1])
        captureCanvasCtx.fillStyle = grad
        captureCanvasCtx.fillRect(
          0,
          0,
          captureCanvas.width,
          captureCanvas.height,
        )
      }

      const drawBackgroundColor = (color) => {
        captureCanvasCtx.fillStyle = color
        captureCanvasCtx.fillRect(
          0,
          0,
          captureCanvas.width,
          captureCanvas.height,
        )
      }

      // 截图canvas内容
      const drawGameContent = async () => {
        // 隐藏场景，修改场景节点位置到10000x，并展示场景做场景节点截图
        const getSceneSnapshot = (scene) => {
          const isVisible = scene.visible
          let cover = ''
          if (!isVisible) {
            scene.x = 10000
            scene.visible = true
          }
          cover = scene.snapshotAsImage()
          if (!isVisible) {
            scene.visible = false
            scene.x = 0
          }
          return cover
        }

        if (
          sceneNode &&
          state.sceneManager.currentSceneNode &&
          sceneNode.uuid === state.sceneManager.currentSceneNode.uuid
        ) {
          // 截取当前场景
          const picGame = await getImage(gameCanvas.toDataURL('image/png'))
          // captureCanvasCtx.drawImage(picGame.dom, 0, 0, captureCanvas.width, captureCanvas.height)
          if (picGame && picGame.dom) {
            captureCanvasCtx.drawImage(
              picGame.dom,
              0,
              0,
              captureCanvas.width,
              captureCanvas.height,
            )
          }
        } else if (sceneNode) {
          // 截取非当前场景
          const sceneConfig = sceneConfigScript.getScript(sceneNode)
          const playScene = sceneConfig.playUUID
            ? nodePool.find(sceneConfig.playUUID)
            : ''

          // 玩法场景
          if (playScene) {
            const playSceneCover = getSceneSnapshot(playScene)
            const img = await getImage(playSceneCover.src)
            captureCanvasCtx.drawImage(
              img.dom,
              0,
              0,
              captureCanvas.width,
              captureCanvas.height,
            )
          }
          // 绘制全局置底
          if (
            globalScene &&
            sceneConfig.isShowGlobal &&
            sceneConfig.globalLevel === sceneConfigScript.GlobalLevel.BOTTOM
          ) {
            const globalSceneCover = getSceneSnapshot(globalScene)
            const img = await getImage(globalSceneCover.src)
            captureCanvasCtx.drawImage(
              img.dom,
              0,
              0,
              captureCanvas.width,
              captureCanvas.height,
            )
          }

          // 当前场景
          if (sceneNode) {
            const cover = getSceneSnapshot(sceneNode)
            const img = await getImage(cover.src)
            captureCanvasCtx.drawImage(
              img.dom,
              0,
              0,
              captureCanvas.width,
              captureCanvas.height,
            )
          }

          // 绘制全局置顶
          if (
            globalScene &&
            sceneConfig.isShowGlobal &&
            sceneConfig.globalLevel === sceneConfigScript.GlobalLevel.TOP
          ) {
            const globalSceneCover = getSceneSnapshot(globalScene)
            const img = await getImage(globalSceneCover.src)
            captureCanvasCtx.drawImage(
              img.dom,
              0,
              0,
              captureCanvas.width,
              captureCanvas.height,
            )
          }
        }

        const dataURL = captureCanvas.toDataURL('image/png')
        document.body.removeChild(captureCanvas)
        // 获取图片失败，截图异常，不保存最终结果
        if (!captureError) {
          resolve(dataURL)
        } else {
          resolve('')
        }
      }

      const drawVideoContent = async () => {
        // const iframeWindowUrl = getIframe().location.href.substr(
        //   0,
        //   getIframe().location.href.lastIndexOf('/'),
        // )
        if (videoNodes.length > 0) {
          const icons = videoNodes
            .filter((node) => {
              return (
                node &&
                node.Video &&
                node.Video.videoCanvas &&
                node.Video.videoCanvas.src
              )
            })
            .map((node) => {
              const videoCoverUrl = node.Video.videoCanvas.src
              return getImage(videoCoverUrl, true)
            })

          const resIcons = await Promise.all(icons)
          videoNodes.forEach((node, index) => {
            const { transformX, transformY } = transformXyLogic2Ui(node)
            const orientationMap = [
              { width: 1334, height: 750 },
              { width: 750, height: 1334 },
            ]
            if (resIcons[index] && resIcons[index].dom) {
              // 画布尺寸 750 * 1334
              captureCanvasCtx.drawImage(
                resIcons[index].dom,
                transformX * worldScale.x,
                transformY * worldScale.y,
                (node.width / orientationMap[orientation].width) *
                  captureCanvas.width,
                (node.height / orientationMap[orientation].height) *
                  captureCanvas.height,
              )
            }
          })
        }
        // 绘制游戏节点
        drawGameContent()
      }

      const drawBackgroundImage = (image) => {
        let sx, sy, sw, sh
        const canvasRatio = captureCanvas.width / captureCanvas.height
        const imgRatio = image.width / image.height
        if (imgRatio <= canvasRatio) {
          sw = image.width
          sh = sw / canvasRatio
          sx = 0
          sy = (image.height - sh) / 2
        } else {
          sh = image.height
          sw = sh * canvasRatio
          sx = (image.width - sw) / 2
          sy = 0
        }
        captureCanvasCtx.drawImage(
          image,
          sx,
          sy,
          sw,
          sh,
          0,
          0,
          captureCanvas.width,
          captureCanvas.height,
        ) // 因为是cover覆盖， 所以dx,dy都是0，绘制宽高即为canvas宽高
      }
      // 绘制背景图
      // 如果基础包的背景图本身就是一个Image的图层，则也不需要绘制背景图层

      if (hasBgImg && gamePlay.div && picBg && picBg.dom) {
        drawBackgroundImage(picBg.dom)
      }
      // 绘制背景色
      if (bgColor && bgColor.isLinear) {
        drawLinearGradient(bgColor.color)
      } else if (bgColor) {
        drawBackgroundColor(bgColor.color)
      }
      drawVideoContent()
    }

    setTimeout(() => {
      finalCanvas()
    }, 100)
  })
}
